import React from 'react';
import { useParams } from 'react-router-dom';

import { OfferUpdatePageContainer } from '@occc-app/offerHelpers/components/OfferUpdatePageContainer';
import { OfferType } from '@occc-app/offerValidationService/types';
import { useChainId } from '@occc-app/Chain/hooks';
import { getUpdatePageLinks, useGetCampaignName } from '@occc-app/routes/CampaignComponents/utils';

import { SweepstakesConfigureFormContainer } from '../SweepstakesConfigureFormContainer';
import { messages } from '../messages';
import { getTargetTabProps } from '../utils';

export const SweepstakesUpdatePageContainer: React.FC = () => {
  // TODO: it might be possible to have this line inside "CampaignComponentUpdatePageContainer" component
  const { id: campaignId = '', sweepstakesId = '' } = useParams<{
    id: string;
    sweepstakesId: string;
  }>();
  const chainId = useChainId();
  const campaignName = useGetCampaignName(chainId, campaignId);
  const getBreadcrumbLinks = (campaignComponentName: string) =>
    getUpdatePageLinks({
      campaignId,
      campaignComponentId: sweepstakesId,
      campaignName,
      pageTitle: messages.configurePageTitle,
      campaignComponentName,
    });

  return (
    <OfferUpdatePageContainer
      campaignId={campaignId}
      offerId={sweepstakesId}
      getBreadcrumbLinks={getBreadcrumbLinks}
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      offerType={OfferType.Sweepstakes}
      targetTabProps={getTargetTabProps}
      ConfigureFormContainer={SweepstakesConfigureFormContainer}
    />
  );
};
